// frontend/src/pages/PVPage.jsx
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { authFetch } from "../utils/authFetch";

const API_URL = process.env.REACT_APP_API_URL || "";

const PVPage = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await authFetch(`${API_URL}/api/pv/`);
      const json = await res.json();
      setRows(Array.isArray(json) ? json : []);
    } catch (e) {
      console.error(e);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>🏪 Punti Vendita</h3>
        <div>
          <Link to="/pv/nuovo" className="btn btn-primary">+ Nuovo Punto Vendita</Link>
        </div>
      </div>

      {loading ? (
        <p>Caricamento…</p>
      ) : rows.length === 0 ? (
        <div className="alert alert-info">Nessun punto vendita registrato.</div>
      ) : (
        <div className="table-responsive">
          <table className="table table-hover align-middle">
            <thead>
              <tr>
                <th>Codice</th>
                <th>Nome</th>
                <th>Referente</th>
                <th>Telefono</th>
                <th>Utente</th>
                <th>Clienti</th>
                <th>Ordini</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {rows.map(row => (
                <tr key={row.id} onClick={() => navigate(`/pv/${row.id}`)} style={{ cursor: "pointer" }}>
                  <td>{row.code}</td>
                  <td>{row.name}</td>
                  <td>{row.referent || "—"}</td>
                  <td>{row.telefono || "—"}</td>
                  <td>{row.username || row.email || "—"}</td>
                  <td>{row.num_clienti ?? 0}</td>
                  <td>{row.num_ordini ?? 0}</td>
                  <td>
                    <Link to={`/pv/${row.id}`} className="btn btn-outline-secondary btn-sm">
                      Dettagli
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default PVPage;
